import * as React from 'react';

import { Button } from 'src/registry/ui/Button';
import { Calendar, type CalendarProps } from 'src/registry/ui/Calendar';
import { Popover, PopoverContent, PopoverTrigger } from 'src/registry/ui/Popover';

interface SingleDatePickerProps extends Omit<React.HTMLAttributes<HTMLInputElement>, 'onSelect' | 'onChange'> {
    value?: Date;
    buttonValue: string;
    onChange: (date: Date | undefined) => void;
    /** Show month/year selects in the calendar caption instead of a plain label. */
    captionLayout?: CalendarProps['captionLayout'];
}

const SingleDatePicker = ({ onChange, value, buttonValue, captionLayout }: SingleDatePickerProps) => {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button id="date" variant="outline" className="justify-center p-2 text-sm font-normal">
                    {buttonValue}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start" side="bottom">
                <Calendar
                    mode="single"
                    onSelect={onChange}
                    onDayClick={onChange}
                    timeZone="UTC"
                    selected={value}
                    defaultMonth={value}
                    required={false}
                    captionLayout={captionLayout}
                />
            </PopoverContent>
        </Popover>
    );
};

export default SingleDatePicker;
